module.exports = __webpack_public_path__ + "img/Logo_KIA.f1bbd00f.svg";